<template>
  <div class="backContainer">
    <div class="btnBack ripple" @click.prevent="volver()">
      <fai icon="arrow-left" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    volver() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.btnBack {
  cursor: pointer;
  background-color: $azulOscuroMMT;
  font-weight: bold;
  color: white;
  position: fixed;
  bottom: 0.5rem;
  right: 0.5rem;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
